export default {
    data() {
        return {
            contlist: [
                {
                    linkUrl: 'https://www.rayscloud.cn/tyrzapi/upload/apk/xiaobang_v2.0.0.apk',
                    img: require('../../assets/az.png'),
                    title: '校帮app（安卓）'
                },
                {
                    linkUrl: 'https://apps.apple.com/cn/app/%E6%A0%A1%E5%B8%AE%E6%99%BA%E6%85%A7%E6%A0%A1%E5%9B%AD/id1608636496',
                    img: require('../../assets/ios.png'),
                    title: '校帮app（IOS）'
                }
            ]
        }
    },
    methods: {

    },
    created() {

    },
}